var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRockruitLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.07257 7.90104C6.97755 7.90104 8.52184 6.46924 8.52184 4.70302C8.52184 2.93681 6.97755 1.505 5.07257 1.505C3.16758 1.505 1.62329 2.93681 1.62329 4.70302C1.62329 6.46924 3.16758 7.90104 5.07257 7.90104Z",
    fill: "#3E50F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9274 9.40594C18.7289 9.40594 20.9999 7.30035 20.9999 4.70297C20.9999 2.10559 18.7289 0 15.9274 0C13.126 0 10.855 2.10559 10.855 4.70297C10.855 7.30035 13.126 9.40594 15.9274 9.40594Z",
    fill: "#3E50F2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.07246 18.9999C7.87391 18.9999 10.1449 16.8943 10.1449 14.297C10.1449 11.6996 7.87391 9.59399 5.07246 9.59399C2.27102 9.59399 0 11.6996 0 14.297C0 16.8943 2.27102 18.9999 5.07246 18.9999Z",
    fill: "#3E50F2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9275 17.495C17.8325 17.495 19.3768 16.0632 19.3768 14.297C19.3768 12.5308 17.8325 11.099 15.9275 11.099C14.0226 11.099 12.4783 12.5308 12.4783 14.297C12.4783 16.0632 14.0226 17.495 15.9275 17.495Z",
    fill: "#3E50F2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRockruitLogo);
export default __webpack_public_path__ + "static/media/RockruitLogo.a562d3e0527b183bc33047c84ec1faa2.svg";
export { ForwardRef as ReactComponent };